export default [
  { to: 'nyheter', title: 'Nyheter' },
  { to: 'stod_i_arbetet', title: 'Stöd i arbetet' },
  { to: 'utbildningar', title: 'Utbildningar' },
  { to: 'kontaktvagar', title: 'Kontaktvägar' },
  { to: 'krispocket', title: 'Krispocket' },
];
